import React from "react";
import { Card, CardContent, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { KanbanBoardItem } from "./kanbanTypes";

interface KanbanProjectCardProps {
  item: KanbanBoardItem;
}

/**
 * A read-only card for one kanban board entry.
 */
const KanbanProjectCard = ({ item }: KanbanProjectCardProps) => {
  const navigate = useNavigate();

  return (
    <Card
      onClick={() => navigate(item.href)}
      sx={{
        mb: 1,
        cursor: "pointer",
        "&:hover": { boxShadow: 3 },
      }}
    >
      <CardContent sx={{ p: 1.5, "&:last-child": { pb: 1.5 } }}>
        <Typography variant="subtitle2" fontWeight="bold" noWrap>
          {item.title}
        </Typography>
        {item.details.map((detail, index) => (
          <Typography key={`${item.id}-${index}`} variant="caption" color="text.secondary" display="block" noWrap>
            {detail}
          </Typography>
        ))}
      </CardContent>
    </Card>
  );
};

export default KanbanProjectCard;
